import { useContext } from 'react';
import { EventContext, type EventContextType } from '../contexts/eventContextTypes';

export const useEvent = (): EventContextType => {
  const context = useContext(EventContext);
  if (context === undefined) {
    throw new Error('useEvent must be used within an EventProvider');
  }
  return context;
};

